// FR
export const hotelRoomsManager = {
  header: {
    eyebrow: "Chambres d'hôtel",
    title: "Gestion des chambres",
    subtitle:
      "Créez des types de chambres et générez les unités physiques avec leur numérotation. Ces chambres se synchroniseront avec Channex.",
    addRoom: "Ajouter une chambre",
  },
  states: {
    loading: "Chargement des chambres...",
    emptyTitle: "Aucune chambre pour le moment",
    emptySubtitle:
      "Créez le premier type de chambre pour commencer à configurer les tarifs et la disponibilité dans Channex.",
    addFirstRoom: "Ajouter la première chambre",
  },
  card: {
    roomsBadge: "{count} chambre | {count} chambres",
    maxGuests: "Max. {count} personnes",
    editTitle: "Modifier la chambre",
    deleteTitle: "Supprimer la chambre",
    adults: "{count} adulte | {count} adultes",
    children: "{count} enfant | {count} enfants",
    infants: "{count} bébé | {count} bébés",
    units: "Unités",
  },
  physical: {
    title: "Chambres physiques",
    subtitle:
      "Modifiez le numéro ou le nom de chaque chambre, ou déplacez-la vers un autre type. Ses réservations la suivent. Faites-les glisser par la poignée pour les ordonner au sein de leur type : c'est l'ordre que vous verrez dans le calendrier.",
    roomsCount: "{count} chambre | {count} chambres",
    savingOrder: "Enregistrement de l'ordre…",
    selectAll: "Tout sélectionner",
    clearSelection: "Effacer la sélection",
    dragToOrder: "Glisser pour réordonner",
    selectRoom: "Sélectionner {label}",
    roomFallback: "chambre",
    codePlaceholder: "N° / code",
    namePlaceholder: "Nom",
  },
  bar: {
    selectedCount: "chambre sélectionnée | chambres sélectionnées",
    clearSelection: "Effacer la sélection",
    changeType: "Changer de type",
  },
  modal: {
    createTitle: "Nouvelle chambre",
    editTitle: "Modifier la chambre",
    createSubtitle: "Définissez le type et générez les unités physiques",
    editSubtitle: "Mettez à jour les détails du type de chambre",
    basicInfo: "Informations de base",
    nameLabel: "Nom de la chambre",
    namePlaceholder: "Ex. Chambre double, Suite junior…",
    descriptionLabel: "Description",
    optional: "(facultatif)",
    descriptionPlaceholder: "Vue mer, terrasse, minibar…",
    inventorySection: "Inventaire et capacité",
    countLabel: "Nombre de chambres",
    countHintZero:
      "Créé sans chambres : vous pourrez ensuite lui attribuer des chambres existantes depuis la liste des chambres physiques.",
    countHint: "Total des unités physiques de ce type",
    capacityLabel: "Capacité totale (personnes)",
    capacityHint: "Maximum autorisé entre adultes + enfants + bébés",
    priceLabel: "Prix par nuit",
    priceHint:
      "Cela crée son tarif standard. Vous pourrez l'ajuster plus tard dans « Tarifs hôtel ».",
    adultsLabel: "Adultes",
    childrenLabel: "Enfants",
    infantsLabel: "Bébés",
    numberingSection: "Numérotation des chambres",
    toggleOn: "Activé",
    toggleOff: "Désactivé",
    numberingHintCreate:
      "Les chambres sont créées avec un code automatique. Vous pouvez le modifier une par une dans la liste des chambres physiques, ou définir la numérotation depuis « Modifier » pour que les suivantes en héritent.",
    prefixLabel: "Préfixe de code",
    prefixPlaceholder: "Ex. 10  ou  A-",
    prefixHint: 'Ex. préfixe « 10 » + début 1 → 101, 102…',
    startNumberLabel: "Numéro de départ",
    paddingLabel: "Remplissage",
    paddingHint: "3 → 001, 002…",
    nameModeLabel: "Noms des chambres physiques",
    nameModeType: "Type uniquement",
    nameModeTypeExample: "Double",
    nameModeTypeCode: "Type + code",
    nameModeTypeCodeExample: "Double 101",
    preview: {
      lead: "Nous allons créer",
      roomsNoun: "chambre | chambres",
      withNumbering: "avec cette numérotation. Exemple :",
    },
    numberingHintKeep:
      "Les chambres existantes conservent leur numéro. Cette numérotation s'appliquera à celles que vous ajouterez désormais.",
    numberingHintZero:
      "Sans chambres, il n'y a rien à numéroter. Attribuez-lui des chambres existantes depuis la liste des chambres physiques.",
    numberingHintDisabled:
      "Les chambres physiques ne seront pas générées automatiquement. Vous pouvez l'activer quand vous le souhaitez.",
    cancel: "Annuler",
    saving: "Enregistrement…",
    creating: "Création…",
    saveChanges: "Enregistrer les modifications",
    createRoom: "Créer la chambre",
  },
  delete: {
    title: "Supprimer la chambre",
    subtitle: "Cette action est irréversible",
    confirmCopy: "Saisissez le nom de la chambre pour confirmer :",
    placeholder: "Nom de la chambre",
    cancel: "Annuler",
    deleting: "Suppression...",
    confirm: "Supprimer",
  },
  change: {
    title: "Changer le type {target}",
    subtitle: "Le numéro de la chambre ne change pas",
    newTypeLabel: "Nouveau type",
    newTypePlaceholder: "Choisissez le type vers lequel la déplacer…",
    blocksHead: "Une réservation bloque le changement | {count} réservations bloquent le changement",
    moves: "Passe au nouveau type",
    stays: "Reste dans son type actuel",
    addMissing: "Ajoutez {labels} au changement et réessayez",
    stockLabel: "Chambres en vente",
    checkingReservations: "Vérification des réservations présentes dans {target}…",
    thisRoom: "cette chambre",
    theseRooms: "ces chambres",
    theRoom: "la chambre",
    theRooms: "les chambres",
    noReservations: "Il n'y a aucune réservation dans {target}.",
    reservationsLeave: "réservation part | réservations partent",
    with: "avec {target}",
    moreReservations: "et {count} réservation de plus | et {count} réservations de plus",
    greyLegend: "Les chambres en gris restent dans leur type actuel.",
    retry: "Réessayer",
    cancel: "Annuler",
    applying: "Changement…",
    confirm: "Oui, changer le type",
    titleTargetOne: "de la chambre {label}",
    titleTargetMany: "de {count} chambre | de {count} chambres",
    textZero: "Ces chambres sont déjà de ce type : choisissez-en un autre pour les déplacer.",
    textOne:
      "La chambre conserve son numéro et ses réservations : seul le type sous lequel elle est vendue change. Là où elle se trouve actuellement, il y aura une chambre de moins en vente, et dans le nouveau type, une de plus.",
    textMany:
      "Les {count} chambres conservent leur numéro et leurs réservations : seul le type sous lequel elles sont vendues change. Là où elles se trouvent actuellement, il y aura {count} chambres de moins en vente, et dans le nouveau type, {count} de plus.",
  },
  blockTitles: {
    huespedDentro: "Un client a fait son check-in",
    reservaRepartida: "La réservation occupe d'autres chambres",
    reservaSinAsignar: "Il manque des chambres à la réservation",
    fallback: "Impossible à déplacer",
  },
  groups: {
    noType: "Aucun type attribué",
  },
  reservation: {
    noName: "Sans nom",
  },
  toasts: {
    roomsChanged: "Chambre changée de type | {count} chambres changées de type",
    changedSyncing: "{done} · mise à jour des canaux",
    created: "Chambre créée avec succès",
    updated: "Chambre mise à jour",
    deleted: "Chambre supprimée",
  },
  errors: {
    generic: "Une erreur s'est produite.",
    loadRooms: "Erreur lors du chargement des chambres",
    updateQty: "Impossible de mettre à jour la quantité",
    savePhysicalRoom: "Impossible d'enregistrer la chambre",
    saveOrder: "Impossible d'enregistrer l'ordre des chambres.",
    checkReservations: "Impossible de vérifier les réservations présentes dans ces chambres.",
    changeType: "Impossible de changer le type de chambre.",
    noProperty: "Impossible de récupérer l'hébergement. Veuillez réessayer.",
    saveRoom: "Erreur lors de l'enregistrement de la chambre",
    deleteRoom: "Erreur lors de la suppression",
  },
};
